import MobileDetect from 'mobile-detect';
const safariRegex = /^((?!chrome|android).)*safari/i;
function isSafari() {
    return safariRegex.test(window.navigator.userAgent);
}
function isTablet() {
    return !!new MobileDetect(window.navigator.userAgent).tablet();
}
function isMobile() {
    return !!new MobileDetect(window.navigator.userAgent).phone();
}
export function isMac() {
    return window.navigator.userAgent.indexOf('Macintosh') !== -1;
}
export function isMobileSafari() {
    return (isMobile() || isTablet()) && isSafari();
}
export function detectWebkitInAppBrowser() {
    const standalone = navigator.standalone; // only webkit has this property
    const isSafari = /safari/i.test(navigator.userAgent); // all browsers on iOS report Safari in the userAgent
    return standalone === false && !isSafari;
}
export function iPhoneMachineId() {
    const match = /iPhone(\d+,\d+)/gi.exec(navigator.userAgent);
    if (match === null)
        return undefined;
    return parseFloat(match[1].replace(',', '.'));
}
// not supported on some iOS devices
export function setDifference(a, b) {
    const diff = new Set();
    for (const it of a)
        if (!b.has(it))
            diff.add(it);
    for (const it of b)
        if (!a.has(it))
            diff.add(it);
    return diff;
}
